import * as React from 'react'

import type {SeqProps} from '../components/common/SequenceLoader/SequenceLoader.types'
import {getBuild, getBuildType} from '../selectors'
import type {ActiveEntityProps} from '../types'

import {useAppSelector} from 'src/hooks/react-redux'

export const EntityContext: React.Context<ActiveEntityProps> = React.createContext(
  Object.freeze({}),
)
type Props = ActiveEntityProps &
  SeqProps & {
    children: React.ReactNode
  }

function EntityProviderComponent({
  projectId,
  buildTypeId,
  pipelineId,
  buildId,
  agentId,
  agentPoolId,
  agentTypeId,
  testId,
  children,
}: Props) {
  const resolvedPieplineId = useAppSelector(state => pipelineId ?? getBuild(state, buildId))

  const resolvedBuildTypeId = useAppSelector(
    state => buildTypeId ?? getBuild(state, buildId)?.buildType,
  )
  const resolvedProjectId = useAppSelector(
    state => projectId ?? getBuildType(state, buildTypeId)?.projectId,
  )
  const contextValue = React.useMemo(
    () => ({
      projectId: resolvedProjectId,
      buildTypeId: resolvedBuildTypeId,
      pipelinedId: resolvedPieplineId,
      buildId,
      agentId,
      agentPoolId,
      agentTypeId,
      testId,
    }),
    [
      agentId,
      agentPoolId,
      agentTypeId,
      buildId,
      resolvedBuildTypeId,
      resolvedPieplineId,
      resolvedProjectId,
      testId,
    ],
  )
  return <EntityContext value={contextValue}>{children}</EntityContext>
}

export const EntityProvider = React.memo(EntityProviderComponent)
